import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import _ from "lodash";
import clsx from "clsx";
import LoadingOverlay from "../../components/LoadingOverlay";
import React from "react";
import { useForm } from "react-hook-form";
import * as axiosInstance from "../../services/axiosInstance";
import PAGE from "../../utils/Destination";

function UserActivation({ history }) {
  const [loading, setLoading] = React.useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const onSubmit = async (values) => {
    const { email, trading_id } = values;
    // const decodedEmail = decodeURIComponent(email);
    setLoading(true);

    try {
      const response = await axiosInstance.post(
        "clientarea/auth/activate",
          {...values,trading_id: trading_id.toUpperCase()},
        true,
        false,
        "Please check your email",
      );
      history.push(PAGE.SUCCESSFUL_ACTIVATE);
    } catch (error) {
      //do nothing
    } finally {
      setLoading(false);
    }
  };

  const onclickBackToLogin = () => {
    history.push(PAGE.LOGIN);
  };

  return (
    <div className="col-xxl-4 col-lg-5 col-md-7">
      <div className="card">
        <div className="card-header pt-4 pb-4 text-center">
          <span>
            <Image src="/img/ta-securities-logo.png" style={{ height: "55px", width: "auto" }} />
          </span>
        </div>
        <div className="card-body">
          <div className="text-center w-75 m-auto">
            <FontAwesomeIcon
              icon={faCircleQuestion}
              style={{ color: "#9D7905", fontSize: "20px", margin: "15px 0" }}
            />
            <h4 className="text-dark-50 text-center mt-0 font-weight-bold title">User Activation</h4>
            <p className="text-muted text-small mb-4">
              Enter your client code and email to activate your account.
            </p>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between">
                <Form.Label className="formLabel required">Username</Form.Label>
                <a
                    href={PAGE.FAQ}
                    className="gridLink"
                    style={{fontSize: "0.65rem", textAlign: "center", justifyContent: "center"}}
                    target="_blank"
                >
                  <span>FAQ</span>
                </a>
              </div>
              <Form.Control
                  isInvalid={!_.isEmpty(errors && errors.trading_id)}
                  name="trading_id"
                  className="formControl auto-uppercase"
                  type="text"
                  placeholder="Enter your client code"
                  {...register("trading_id", {required: "Client code is required"})}
                />
                {errors.trading_id && (
                    <Form.Control.Feedback type="invalid">{errors.trading_id.message}</Form.Control.Feedback>
                )}
            </Form.Group>
            <Form.Group className="mb-3">
            <Form.Label className="formLabel required">Email Address</Form.Label>
              <Form.Control
                isInvalid={!_.isEmpty(errors && errors.email)}
                className="formControl"
                name="email"
                type="email"
                placeholder="Enter your email"
                {...register("email", { required: "Email address is required" })}
              />
              {errors.email && (
                <Form.Control.Feedback type="invalid">{errors.email.message}</Form.Control.Feedback>
              )}
            </Form.Group>
            {/*<span>*/}
            {/*  *Please <a className="negative-number">contact admin</a> to reset your password if you don't*/}
            {/*  know your email or without email.*/}
            {/*</span>*/}
            <div className="text-center">
              <button className={clsx("btn btn-primary btn-fill mt-2 mb-4")} type="submit">
                Activate
              </button>
            </div>
          </Form>
        </div>
        <LoadingOverlay loading={loading}></LoadingOverlay>
      </div>

      <div className="row mt-3">
        <div className="col-12 text-center">
          <p className="text-black-50">
            Back to{" "}
            <a href="#" onClick={onclickBackToLogin} className="ms-1">
              <b>Log In</b>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default UserActivation;
